import {
  actionCreator, API_URL,
  checkHttpStatus, create_post_data, createRequestActionTypes, createSearchUrl, jsonApiHeader,
  showErrorMessage, showSuccessMessage, showWarningMessage,
} from './../../../../../actions/utilAction';

export { jsonApiHeader, showWarningMessage, showErrorMessage, actionCreator, checkHttpStatus, create_post_data, createSearchUrl, showSuccessMessage };


export const APPOINTMENT_TYPE_API = `${API_URL}/appointment-type`;
export const GET_APPOINTMENT_TYPE_LIST_API = `${API_URL}/AppointmentTypes/GetAppointmentType`;
export const POST_APPOINTMENT_TYPE_API = `${API_URL}/AppointmentTypes/SaveAppointmentType`;
export const GET_APPOINTMENT_TYPE_DETAIL_API = `${API_URL}/AppointmentTypes/GetAppointmentTypeById`;
export const DELETE_APPOINTMENT_TYPE_API = `${API_URL}/AppointmentTypes/DeleteAppointmentType`;
export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;

export const appointmentTypeActionTypes = {
  get_masterData: createRequestActionTypes('GET_MASTERDATA'),
  save_appointmentType: createRequestActionTypes('SAVE_APPOINTMENTTYPE'),
  get_appointmentTypeList: createRequestActionTypes('GET_APPOINTMENTTYPELIST'),
  get_appointmentTypeDetail: createRequestActionTypes('GET_APPOINTMENTTYPEDETAIL'),
  delete_appointmentType: createRequestActionTypes('DELETE_APPOINTMENTTYPE'),

};
export const MODULE = 'MASTER_APPOINTMENT';



// WEBPACK FOOTER //
// ./src/modules/Masters/components/appointment-type/constants/ApiConstants.js